// @ts-expect-error - UserFragment is needed for the fragment spread
// eslint-disable-next-line
import { UserFragment } from "../fragments/User.fragment";
import { graphql } from "@/codegen/graphql/generated";

export const REGISTER = graphql(`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      token
      user {
        ...UserFragment
      }
    }
  }
`);
